import { render, staticRenderFns } from "./SaveWarning.vue?vue&type=template&id=f84f4a78&scoped=true"
import script from "./SaveWarning.vue?vue&type=script&lang=js"
export * from "./SaveWarning.vue?vue&type=script&lang=js"
import style0 from "./SaveWarning.vue?vue&type=style&index=0&id=f84f4a78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f84f4a78",
  null
  
)

export default component.exports